import React from 'react'
import AllDishes from '../Components/AllDishes'
import AllDishesNav from '../Components/AllDishesNav'

const Dishes = () => {
  return (
    <div>
        <AllDishesNav />
        <AllDishes />
    </div>
  )
}

export default Dishes